import { Fragment } from "react";

import { useHistory } from "react-router-dom";

import EditIcon from "@material-ui/icons/Edit";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import { setStatusBackToSummary } from "../../Context/NewSubscriberAction";
import { Box, Typography } from "@material-ui/core";
import { SummaryCard } from "../../../transactions/newInvestor/lib/CardComponent2";

const labelText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#002856",
  lineHeight: "16px",
};

const bodyText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#000000",
  lineHeight: "16px",
};

const BankDetailsPreview = () => {
  // const { bankDetailsPreview = {} } = useSelector(
  //   (state) => state.newSubscriber.preview
  // );
  const history = useHistory();
  const {
    bankDetails,
    pennyDropResponse,
    dispatch: contextDispatch,
    accountType,
    tier2PennyDrop = {},
  } = useNewSubscriberContext();

  const AccountDetails = pennyDropResponse?.data?.data?.result;
  const tier2AccountDetails = tier2PennyDrop?.data?.data?.result;

  const {
    BankAccountNumber = "-",
    BankIFCS = "-",
    BankName = "-",
    BankAccountTypeDes = "-",
    T2BankAccountNumber,
    T2BankIFSC,
    T2BankName,
    T2SelectedAccountType,
  } = bankDetails?.data;
  const back = () => {
    contextDispatch(setStatusBackToSummary(true));
    history.push({
      pathname: "/nps/AddSubs/bank-details",
    });
  };
  return (
    <Fragment>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          BANK DETAILS
        </div>
        <EditIcon className="cursor" onClick={back} />
      </div>
      <SummaryCard title="TIER I">
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gridRowGap: "2rem",
            padding: "20px 6px 20px 6px",
            margin: "0px 5px 20px 10px",
          }}
        >
          <div>
            <Typography style={labelText}>IFS Code</Typography>
            <Typography style={bodyText}>
              {BankIFCS || AccountDetails.ifsc}
            </Typography>
          </div>
          <div>
            <Typography style={labelText}>Bank Name</Typography>
            <Typography style={bodyText}>
              {BankName || AccountDetails.accountName}
            </Typography>
          </div>
          <div>
            <Typography style={labelText}>Account Type</Typography>
            <Typography style={bodyText}>{BankAccountTypeDes || ""}</Typography>
          </div>
          <div>
            <Typography style={labelText}>Account Number</Typography>
            <Typography style={bodyText}>
              {BankAccountNumber || AccountDetails.accountNumber}
            </Typography>
          </div>
        </Box>
      </SummaryCard>

      {Number(accountType?.data?.AccountType) === 2 ? (
        <>
          <SummaryCard title="TIER II">
            <Box
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gridRowGap: "2rem",
                padding: "20px 6px 20px 6px",
                margin: "0px 5px 20px 10px",
              }}
            >
              <div>
                <Typography style={labelText}>IFS Code</Typography>
                <Typography style={bodyText}>
                  {T2BankIFSC || tier2AccountDetails?.ifsc || "-"}
                </Typography>
              </div>
              <div>
                <Typography style={labelText}>Bank Name</Typography>
                <Typography style={bodyText}>
                  {T2BankName || tier2AccountDetails?.accountName || "-"}
                </Typography>
              </div>
              <div>
                <Typography style={labelText}>Account Type</Typography>
                <Typography style={bodyText}>
                  {Number(T2SelectedAccountType) === 53
                    ? "Savings A/C"
                    : "Current A/C"}
                </Typography>
              </div>
              <div>
                <Typography style={labelText}>Account Number</Typography>
                <Typography style={bodyText}>
                  {T2BankAccountNumber ||
                    tier2AccountDetails.accountNumber ||
                    "-"}
                </Typography>
              </div>
            </Box>
          </SummaryCard>
        </>
      ) : null}
    </Fragment>
  );
};

export default BankDetailsPreview;
